export const RefundReasons = [
  { value: 'duplicate', title: 'Duplicate Payment' },
  { value: 'fraudulent', title: 'Fraudulent' },
  { value: 'requested_by_customer', title: 'Requested by Member' },
  { value: 'other', title: 'other' }
];

export const ShortCodes = [
  { code: '[program name]', key: 'clubProgramName' },
  { code: '[Program Name]', key: 'clubProgramName' },
  { code: '[club name]', key: 'clubName' },
  { code: '[Club Name]', key: 'clubName' },
  { code: '[Player First Name]', key: 'firstName' },
  { code: '[Player Last Name]', key: 'lastName' },
  { code: '[Club Logo]', key: 'clubLogo' },
  { code: '[Club URL]', key: 'clubUrl' },
  { code: '[Invoice Number]', key: 'invoiceNumber' },
  { code: '[Receipt Number]', key: 'receiptNumber' },
  { code: '[Amount Paid]', key: 'amountPaid' },
  { code: '[Date Paid]', key: 'datePaid' },
  { code: '[Payment Method]', key: 'paymentMethod' },
  { code: '[Fee Name]', key: 'feeName' }
];

export const Months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const FullMonthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export enum EStaffRoles {
  ExecutiveDirector = 25,
  CoachingDirector = 26,
  ClubDirector = 11,
  CollegeRecruiter = 18,
  ClubRegistrar = 17,
  // Team Account
  HeadCoach = 3,
  AssistantCoach = 4,
  KeeperCoach = 15,
  TeamAdmin = 7,
  NoRoleAssigned = 0,
  FinancialAdmin = 36,
}

export const StaffRoles = [
  {
    title: 'Director Roles',
    isTeam: false,
    roles: [
      { title: 'Executive Director', value: EStaffRoles.ExecutiveDirector, checked: false },
      { title: 'Director of Coaching', value: EStaffRoles.CoachingDirector, checked: false },
      { title: 'College Recruiter', value: EStaffRoles.CollegeRecruiter, checked: false },
    ]
  },
  {
    title: 'Administration Roles',
    isTeam: false,
    roles: [
      { title: 'Club Registrar', value: EStaffRoles.ClubRegistrar, checked: false },
      { title: 'Financial Admin', value: EStaffRoles.FinancialAdmin, checked: false },
    ]
  },
  {
    title: 'Team Roles',
    isTeam: true,
    roles: [
      { title: 'Head Coach', value: EStaffRoles.HeadCoach, checked: false },
      { title: 'Assistant Coach', value: EStaffRoles.AssistantCoach, checked: false },
      { title: 'Goal Keeper Coach', value: EStaffRoles.KeeperCoach, checked: false },
      { title: 'Team Admin', value: EStaffRoles.TeamAdmin, checked: false },
    ]
  }
];

export enum ProgramsBillingType {
  ClubBilling = 1,
  TryoutBilling = 2,
  TeamBilling = 3,
  TravelBilling = 4,
  RecreationalBilling = 5,
  AssocationRegistration = 8,
  CampsClinics = 6
}

export const ProgramsBillingName = {
  [ProgramsBillingType.ClubBilling]: 'Club Billing',
  [ProgramsBillingType.TryoutBilling]: 'Tryout Registration',
  [ProgramsBillingType.TeamBilling]: 'Team Billing',
  [ProgramsBillingType.TravelBilling]: 'Travel Billing',
  [ProgramsBillingType.RecreationalBilling]: 'Recreation Billing',
  [ProgramsBillingType.CampsClinics]: 'Camps / Clinics',
};

export const ProgramsBaseUrl = {
  [ProgramsBillingType.ClubBilling]: '/',
  [ProgramsBillingType.TeamBilling]: '/team-billing',
  [ProgramsBillingType.TravelBilling]: '/travel-billing',
  [ProgramsBillingType.RecreationalBilling]: '/recreational-billing',
  [ProgramsBillingType.TryoutBilling]: '/tryoutprogram/active',
  [ProgramsBillingType.CampsClinics]: '/camps-clinics-billing',
  [ProgramsBillingType.AssocationRegistration]: '/staff/all/evaluations'
};

const years = [];
for (let i = 2000; i < 2015; i++) {
  years.push(i);
}

export const ValidUrl = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

export const ValidEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export enum AccountTypeID {
  Association = 1,
  ClubAccount = 2,
  TeamAccount = 3,
  EventAccount = 4,
  CollegeAccount = 5,
  ParentAccount = 6,
  HotelAccount = 7,
  ComplexAccount = 8,
  TGSMasterAdminAccount = 9,
  PlayerAccount = 10,
  SuperLeagueAccount = 11
}


// WEBPACK FOOTER //
// ./src/app/models/config.ts